import { Box, Label, Tag } from '@nimbus-ds/components';
import { RadioButtonGroup } from 'commons/components';
import { useTranslationCustomers } from 'domains/Customers/hooks';

interface WholesaleFilterProps {
  value: string;
  onChange: ({ value }) => void;
}

export default function WholesaleFilter({
  value,
  onChange,
}: Readonly<WholesaleFilterProps>) {
  const t = useTranslationCustomers();
  const tPath = 'customerListPage.filterModal.b2bFilter';

  const options = [
    {
      label: t(`${tPath}.all`),
      value: '',
    },
    {
      label: t(`${tPath}.retail`),
      value: 'false',
    },
    {
      label: t(`${tPath}.wholesale`),
      value: 'true',
    },
  ];

  return (
    <Box>
      <Box paddingBottom="2" display="flex" alignItems="center" gap="1">
        <Label>{t(`${tPath}.label`)}</Label>
        <Tag appearance="primary">{t(`${tPath}.tag`)}</Tag>
      </Box>
      <RadioButtonGroup
        name="wholesale-filter"
        options={options}
        onChange={onChange}
        value={value}
      />
    </Box>
  );
}
